import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig, renderDetail } from ".";

export const definition: WidgetDefinition = {
  id: "infringement-records",
  module: { manifest, Component, defaultConfig, renderDetail },
  catalog: {
    description: "Review recent infringement records and their status.",
    domain: "infringements",
    visual: "Table",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "table", skeleton: "table" },
  defaultLayoutClassName: "col-span-12",
};
